import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { CsAgentAuthService } from '@spartacus/asm/root';
import { BaseSiteService, OccEndpointsService } from '@spartacus/core';
import { ICON_TYPE } from '@spartacus/storefront';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { ChartType } from 'chart.js';
import * as html2pdf from 'html2pdf.js';
import * as moment from 'moment';
import { BaseChartDirective } from 'ng2-charts';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { OrderHistoryService } from 'src/app/order-history/order-history.service';
import { LoactionStripService } from 'src/app/shared/modules/location-strip/loaction-strip.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { PaymentHistoryService } from '../payment-history.service';
@Component({
  selector: 'app-latest-payment',
  templateUrl: './latest-payment.component.html',
  styleUrls: ['./latest-payment.component.scss'],
})
export class LatestPaymentComponent implements OnInit {
  PaymentList = [];
  totalPayments: number = 0;
  payments = [];
  userId;
  pageLength = '18 per page';
  timeFrameList = ['Select', '30 Days', '6 Months', '1 Year'];
  pageList = [this.pageLength, '36 per page', '72 per page', 'All'];
  timeFrame = 'Select';
  fromDate: any = undefined;
  toDate: any = undefined;
  poNumber: any;
  order: any;
  invoice: any;
  dateError = false;
  selectedTimeFrame = 'Select';
  pageSizeperPage = this.pageLength;
  pageSize = 18;
  curPage = 1;
  end: number;
  @ViewChild('facetsRwd', { static: false }) private readonly facetsRwd;
  singleDateError = false;
  facetsList: any = [{ type: 'timeFrame', value: '30 Days' }]; // Show 30 Days as applied filter
  filters = {
    fields: 'DEFAULT',
    timeFrame: '3',
    currentPage: this.curPage - 1,
    pageSize: this.pageSize,
  };

  maxSelectionDate = moment(new Date()).endOf('day').toDate();
  minSelectionDate = moment({ year: 2024, month: 5, day: 3 })
    .startOf('day')
    .toDate();
  dateFormat = 'MM/DD/YYYY';
  userDataSubscription: any;
  detailsSubscription: any;
  userInfo: any;
  FilteredData: any;
  allOrdersSubscription: any;
  xlsDownloaded: boolean = false;
  orderStatusList = ['All', 'Applied payments', 'Refunds', 'Overpayments'];
  PaymentMethodList = [
    'All',
    'Electronic Wire',
    'Credit Card',
    'Check',
    'Checking Account',
    'Pay by credit',
    'Credit',
    'Refunds',
    'Adjustment',
    'Overpayments',
    'Electronic Checks',
  ];
  paymentMethod: any = 'All';
  orderStatusSub: Subscription;
  orderStatus = 'All';
  isFilterSelected = false;
  product: any;
  isLocationSelected: boolean;
  selectedLocations: any;
  LocationListSub: Subscription;
  @ViewChild('p1') public actionsPopup: NgbPopover;
  sortTable = {
    code: 1,
    location: 1,
    invoices: 1,
    accNo: 1,
    dueDate: 1,
    paymentDate: 1,
    invoiceNo: 1,
    poNo: 1,
    invoiceAmount: 1,
    discountAmount: 1,
    plannedAmount: 1,
    paymentMethod: 1,
    invoiceBalance: 1,
  };
  sortColumnName: any = '';
  paymentSummaryList: any;

  doughnutChartLabels: any[] = []; //labels is not being set in code.not used
  doughnutChartData: any = [];
  doughnutChartType: ChartType = 'doughnut';
  doughnutChartColors = [
    {
      backgroundColor: [
        '#3182bd',
        '#800000',
        '#001D66',
        '#ff9042',
        '#420943',
        '#b8583c',
        '#902147',
        '#368911',
        '#06a5a1',
        '#254a04',
        '#780a0a',
      ],
    },
  ];
  paymentSummary: any;
  typeSummary: any;
  paymentFromDate: any = moment().subtract(30, 'days').calendar();
  paymentToDate: any = moment().format('L');
  paymentSummaryFilters: {};
  pieChartOptions: any = {
    responsive: false,
    plugins: {
      tooltip: {
        enabled: false,
      },
    },
  };
  displayOnlyValues: any = [];
  filterForm: FormGroup;
  baseSiteId: any;
  baseUrl: any;
  isAsmUser: boolean = false;
  firewallExempt: boolean = false;
  csAgentAuthSubscription: Subscription;
  paymentFullResult: any;
  startCount: number;
  @ViewChild(BaseChartDirective) paymentHistChart: BaseChartDirective;
  doughnutDataSet: {
    data: any[];
    backgroundColor: any[];
    hoverBackgroundColor: any[];
  };
  constructor(
    private readonly fb: FormBuilder,
    private readonly service: OrderHistoryService,
    private readonly user: UserAccountFacade,
    private readonly cd: ChangeDetectorRef,
    private readonly modalService: NgbModal,
    private readonly localeService: BsLocaleService,
    private readonly orderHistoryService: OrderHistoryService,
    private paymentService: PaymentHistoryService,
    private router: Router,
    private locStripService: LoactionStripService,
    private baseSiteService: BaseSiteService,
    private occEndPoint: OccEndpointsService,
    private readonly csAgentAuthService: CsAgentAuthService,
    private readonly sharedService: SharedService
  ) {
    enGbLocale.weekdaysShort = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
    enGbLocale.week.dow = 0;
    defineLocale('en-gb', enGbLocale);
    this.localeService.use('en-gb');
  }

  ngOnInit() {
    this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
    this.filterForm = this.fb.group({
      ponumber: ['', [Validators.required]],
      invoice: ['', [Validators.required]],
    });
    this.cd.detectChanges();
    this.end = this.pageSize;
    this.csAgentAuthSubscription = this.csAgentAuthService
      .isCustomerEmulated()
      .subscribe((res) => {
        this.isAsmUser = res ? res : false;
      });
    // this.firewallExempt = this.sharedService.getSessionStorage('firewallExempt');
    this.orderHistoryService.getOrderStatus({
      enumerationType: 'OrderStatus',
      fields: 'DEFAULT',
    });
    this.LocationListSub = this.locStripService.emitSelectedLocs.subscribe(
      (locsData) => {
        this.isLocationSelected = !!locsData?.length;
        this.selectedLocations = locsData;
      }
    );
    this.getPaymentList();
    this.getPieChartDetailsList();
    this.onValueChanges();
  }

  onValueChanges(): void {
    this.filterForm.get('ponumber').valueChanges.subscribe((val) => {
      if (val) this.isFilterSelected = true;
    });
    this.filterForm.get('invoice').valueChanges.subscribe((val) => {
      if (val) this.isFilterSelected = true;
    });
  }

  getPieChartDetailsList() {
    this.userInfo = this.user.get().subscribe((userData) => {
      this.userId = userData;
      if (userData) {
        const params = { userId: this.userId.uid };
        this.getPaymentSummaryFilter();
        this.paymentService.getPieChartDetails(
          params,
          this.paymentSummaryFilters
        );
        this.detailsSubscription = this.paymentService
          .getPieChartDetails(params, this.paymentSummaryFilters)
          .subscribe((res) => {
            if (res !== null) {
              try {
                this.paymentSummaryList = res?.paymentHistoryList;
                this.paymentSummary = res?.paymentSummary;
                this.typeSummary = Object.values(this.paymentSummary);
                this.typeSummary = this.typeSummary.map(Number);
                this.doughnutDataSet = {
                  data: [],
                  backgroundColor: [],
                  hoverBackgroundColor: [],
                };
                this.doughnutDataSet.data = this.typeSummary;
                this.doughnutDataSet.backgroundColor =
                  this.doughnutChartColors[0]['backgroundColor'];
                this.doughnutDataSet.hoverBackgroundColor =
                  this.doughnutChartColors[0]['backgroundColor'];
                this.doughnutChartData = [];
                this.doughnutChartData?.push(this.doughnutDataSet);
                this.paymentHistChart?.update();
                this.cd.detectChanges();
              } catch {}
            }
          });
      }
    });
  }

  getPaymentSummaryFilter() {
    this.paymentSummaryFilters = {};
    if (this.isLocationSelected) {
      if (this.selectedLocations.length > 1) {
        this.paymentSummaryFilters['accountIds'] = '';
      }
      this.selectedLocations.forEach((loc) => {
        if (this.selectedLocations.length > 1) {
          this.paymentSummaryFilters['accountIds'] =
            this.paymentSummaryFilters['accountIds'] === ''
              ? loc.accountNumber
              : this.paymentSummaryFilters['accountIds'] +
                ',' +
                loc.accountNumber;
        } else {
          this.paymentSummaryFilters['accountIds'] = loc.accountNumber;
        }
      });
    }
    if (this.timeFrame === 'Select') {
      delete this.paymentSummaryFilters['timeFrame'];
    }
    if (this.timeFrame && !this.fromDate && !this.toDate) {
      if (this.timeFrame === '30 Days') {
        this.paymentSummaryFilters['timeFrame'] = '30 days';
      }
      if (this.timeFrame === '3 Months') {
        this.paymentSummaryFilters['timeFrame'] = '3 months';
      }
      if (this.timeFrame === '6 Months') {
        this.paymentSummaryFilters['timeFrame'] = '6 months';
      }
      if (this.timeFrame === '1 Year') {
        this.paymentSummaryFilters['timeFrame'] = '1 year';
      }
    }
    if (this.fromDate && this.toDate) {
      if (
        this.timeFrame === 'Select' &&
        this.paymentSummaryFilters['timeFrame']
      ) {
        delete this.paymentSummaryFilters['timeFrame'];
      }
      this.paymentSummaryFilters['fromDate'] = moment(this.fromDate).format(
        'MM-DD-YYYY'
      );
      this.paymentSummaryFilters['toDate'] = moment(this.toDate).format(
        'MM-DD-YYYY'
      );
    }
  }

  getBackgroundColor(index) {
    return this.doughnutChartColors[0]['backgroundColor'][index];
  }

  refine(): void {
    this.modalService.open(this.facetsRwd, {
      windowClass: `${this.baseSiteId}`,
    });
  }

  hide(): void {
    this.modalService.dismissAll(this.facetsRwd);
  }

  generateInvoicePDF(invoiceNumber) {
    this.service.downloadPdf(invoiceNumber);
  }

  clearPaymentSummaryFilter() {
    this.getPieChartDetailsList();
  }

  deletePaginationFilter() {
    let filters = this.filters;
    delete filters.currentPage;
    delete filters.pageSize;
    return filters;
  }

  generateXlsSheetAndPdf(type) {
    const params = { userId: this.userId.uid };
    this.filters = this.getfilterQuery();
    let filters = this.deletePaginationFilter();
    this.getXlsAndPdf(params, type, filters);
  }

  getXlsAndPdf(params, type, filters?) {
    let str = '';
    for (let prop in filters) {
      str = str + prop + '=' + filters[prop] + '&';
    }
    str = str.substring(0, str.length - 1);
    let url = '';
    this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
    this.baseUrl = this.occEndPoint.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
    if (type == 'excel') {
      url =
        this.baseUrl +
        `/sanofiusocc/v2/${this.baseSiteId}/my-account/${params.userId}/export/excel?` +
        str;
    } else {
      url =
        this.baseUrl +
        `/sanofiusocc/v2/${this.baseSiteId}/my-account/${params.userId}/export/pdf?` +
        str;
    }
    window.location.href = url;
  }

  getPaymentList() {
    this.userInfo = this.user.get().subscribe((userData) => {
      this.userId = userData;
      this.filters = this.getfilterQuery();
      if (userData) {
        const params = { userId: this.userId.uid };
        this.paymentService.getPaymentHistory(params, this.filters);
        this.userDataSubscription = this.paymentService.userData$.subscribe(
          (res) => {
            if (res !== null) {
              try {
                this.paymentFullResult = res;
                this.PaymentList = res?.paymentHistoryList;
                this.totalPayments = res?.pagination?.totalResults;
                this.cd.detectChanges();
                this.formatOrders();
                if (this.curPage > 1) {
                  this.startCount = this.pageSize * this.filters.currentPage;
                }
                if (this.curPage == 1) {
                  this.startCount = 1;
                }
                if (this.PaymentList.length == 0) {
                  this.startCount = 0;
                }
                if (this.pageSize > this.totalPayments) {
                  this.end = this.totalPayments;
                } else {
                  if (this.pageSize < this.totalPayments) {
                    this.end = this.pageSize * this.curPage;
                    if (this.end > this.totalPayments) {
                      this.end = this.totalPayments;
                    }
                  }
                }
                res = null;
                this.cd.detectChanges();
              } catch {}
            }
          }
        );
      }
    });
  }

  goToTransactionalPage(data: any) {
    const transactionalDetailsArray = [];
    data.type = 'recent';
    transactionalDetailsArray.push(data);

    /* May need this commented code in future */

    /*this.paymentSummaryList.forEach(item => {
      if((item.clearingDocNo === data.clearingDocNo)){
        transactionalDetailsArray.push(item);
      }
    });*/
    let val = {
      isComServeAgent: this.paymentFullResult?.isComServeAgent,
      details: transactionalDetailsArray,
    };
    localStorage.setItem('transactionalData', JSON.stringify(val));
    this.router.navigate(['/', 'transactionaldata']);
  }

  ngOnDestroy() {
    this.userDataSubscription?.unsubscribe();
    this.userInfo?.unsubscribe();
    this.allOrdersSubscription?.unsubscribe();
    this.detailsSubscription?.unsubscribe();
  }

  formatOrders() {
    this.payments = [];
    this.PaymentList.forEach((element) => {
      const data = {
        code: element.code,
        location: element?.location,
        invoices: element.invoiceNo,
        accountNumber: element.accountNumber,
        dueDate: element.dueDate,
        paymentDate: element.paymentDate,
        invoiceNo: element.invoiceNo,
        poNo: element.poNo,
        invoiceAmount: element.invoiceAmount,
        discountAmount: element.discountAmount,
        plannedAmount: element.plannedAmount,
        paymentMethod: element.paymentMethod,
        invoiceBalance: element.invoiceBalance,
        indicator: element.indicator,
        clearingDocNo: element.clearingDocNo,
        docType: element.docType,
        docNo: element.docNo,
        ccNum: element.ccNum,
      };
      this.payments.push(data);
    });
  }

  changePageSize() {
    this.curPage = 1;
    if (this.pageSizeperPage === this.pageLength) {
      this.pageSize = 18;
    }
    if (this.pageSizeperPage === '36 per page') {
      this.pageSize = 36;
    }
    if (this.pageSizeperPage === '72 per page') {
      this.pageSize = 72;
    }
    if (this.pageSizeperPage === 'All') {
      this.pageSize = this.totalPayments;
    }
    if (this.pageSize < this.totalPayments) {
      this.end = this.pageSize;
    } else {
      this.end = this.totalPayments;
    }
    this.cd.detectChanges();
  }

  getCurrentPage(type) {
    this.curPage = type === 'prev' ? this.curPage - 1 : this.curPage + 1;
    this.cd.detectChanges();
  }

  numberOfPages() {
    if (this.PaymentList && this.totalPayments && this.pageSize > 0) {
      return Math.ceil(this.totalPayments / this.pageSize);
    } else {
      return 1;
    }
  }

  iconTypes = ICON_TYPE;

  removeFacet(filter) {
    this.facetsList.forEach((element, index) => {
      if (element === filter) {
        this.facetsList.splice(index, 1);
        if (filter.type === 'date') {
          this.fromDate = undefined;
          this.toDate = undefined;
          this.timeFrame = 'Select';
        }
        if (filter.type === 'poNumber') {
          this.poNumber = undefined;
        }
        if (filter.type === 'orderNumber') {
          this.order = undefined;
        }
        if (filter.type === 'invoiceNumber') {
          this.invoice = undefined;
        }
        if (filter.type === 'timeFrame') {
          this.timeFrame = 'Select';
          this.selectedTimeFrame = 'ALL';
        }
        if (filter.type === 'productName') {
          this.product = undefined;
        }
        if (filter.type === 'paymentMethod' || filter.type === 'paymentType') {
          this.paymentMethod = 'All';
        }
        this.curPage = 1;
        this.getPaymentList();
        this.clearPaymentSummaryFilter();
        this.cd.detectChanges();
      }
    });
  }

  applyFilter(type?: string) {
    if (this.fromDate && this.toDate) {
      if (this.fromDate.getTime() > this.toDate.getTime()) {
        this.dateError = true;
        return false;
      } else {
        this.dateError = false;
      }
    }
    const params = { userId: this.userId?.uid };
    this.filters = this.getfilterQuery();
    this.showFacets(JSON.stringify(this.filters));
    this.filters.currentPage = 0;
    this.curPage = 1;
    this.paymentService.getPaymentHistory(params, this.filters);
    this.userDataSubscription = this.service.userData$.subscribe((res) => {
      if (res !== null) {
        this.PaymentList = res?.orders;
        this.totalPayments = res?.pagination?.totalResults;
        this.cd.detectChanges();
        this.formatOrders();
        this.cd.detectChanges();
        this.selectedTimeFrame =
          this.timeFrame == 'Select' ? 'ALL' : this.timeFrame;
        if (type === 'mobile') {
          this.hide();
        }
      }
    });
    this.getPieChartDetailsList();
    this.hide();
    return true;
  }

  showFacets(data) {
    const facets = JSON.parse(data);
    delete facets.fields;
    delete facets.currentPage;
    delete facets.pageSize;
    delete facets?.sortCode;
    delete facets?.sortOrder;
    delete facets?.accountIds;
    if (facets.fromDate) {
      facets.date = `${moment(this.fromDate).format(
        this.dateFormat
      )} - ${moment(this.toDate).format(this.dateFormat)}`;
      delete facets.fromDate;
      delete facets.toDate;
    }
    if (facets.timeFrame != 'ALL') {
      facets.timeFrame = this.timeFrame;
    } else if (facets.timeFrame != 'ALL') {
      delete facets.timeFrame;
    }
    if (facets.productCode) {
      facets.productName = this.product.name;
      delete facets.productCode;
    }
    if (facets.statuses == 'All') {
      delete facets.statuses;
    }
    if (facets.timeFrame === 'Select') {
      delete facets.timeFrame;
    }
    this.facetsList = Object.entries(facets).map(([type, value]) => ({
      type,
      value,
    }));
  }

  getfilterQuery() {
    const data: any = {
      fields: 'DEFAULT',
      currentPage: this.curPage - 1,
      pageSize: this.pageSize,
    };
    if (this.sortColumnName != '') {
      data.sortOrder =
        this.sortTable[this.sortColumnName] === 0 ? 'asc' : 'desc';
      data.sortCode = this.sortColumnName;
    }
    if (this.isLocationSelected) {
      if (this.selectedLocations.length > 1) {
        data.accountIds = '';
      }
      this.selectedLocations.forEach((loc) => {
        if (this.selectedLocations.length > 1) {
          data.accountIds =
            data.accountIds === ''
              ? loc.accountNumber
              : data.accountIds + ',' + loc.accountNumber;
        } else {
          data.accountIds = loc.accountNumber;
        }
      });
    }
    if (this.invoice) {
      data.invoiceNumber = this.invoice;
    }
    if (this.order) {
      data.orderNumber = this.order;
    }
    if (this.poNumber) {
      data.poNumber = this.poNumber;
    }
    if (this.timeFrame && !this.fromDate && !this.toDate) {
      if (this.timeFrame === '30 Days') {
        data.timeFrame = '30 days';
        this.paymentFromDate = moment().subtract(30, 'days').calendar();
      }
      if (this.timeFrame === '3 Months') {
        data.timeFrame = '3 months';
        this.paymentFromDate = moment().subtract(3, 'months').calendar();
      }
      if (this.timeFrame === '6 Months') {
        data.timeFrame = '6 months';
        this.paymentFromDate = moment().subtract(6, 'months').calendar();
      }
      if (this.timeFrame === '1 Year') {
        data.timeFrame = '1 year';
        this.paymentFromDate = moment().subtract(1, 'years').calendar();
      }
    }
    if (this.fromDate && this.toDate) {
      if (this.timeFrame === 'Select' && data.timeFrame) {
        delete data.timeFrame;
      }
      data.fromDate = moment(this.fromDate).format('MM-DD-YYYY');
      data.toDate = moment(this.toDate).format('MM-DD-YYYY');
      this.paymentFromDate = moment(this.fromDate).format('L');
      this.paymentToDate = moment(this.toDate).format('L');
    } else if (
      (!this.fromDate && this.toDate) ||
      (this.fromDate && !this.toDate)
    ) {
      this.singleDateError = true;
    }
    if (this.product) {
      data.productCode = this.product.code;
    }

    if (this.paymentMethod) {
      data.paymentMethod = this.paymentMethod;
    }
    if (this.paymentMethod === 'All') {
      delete data.paymentMethod;
    }
    return data;
  }

  sortColumnByApi(type, event) {
    this.sortTable[type] = this.sortTable[type] === 1 ? 0 : 1;
    this.sortColumnName = type;
    this.getPaymentList();
    let sortDir = 1;
    const caretUpClass = 'fa-caret-up';
    const caretDownClass = 'fa-caret-down';
    const target = event.currentTarget.children;
    const classList = target[0].classList;

    if (classList.contains(caretUpClass)) {
      classList.remove(caretUpClass);
      classList.add(caretDownClass);
      sortDir = -1;
    } else {
      classList.add(caretUpClass);
      classList.remove(caretDownClass);
      sortDir = 1;
    }
  }

  validateDate() {
    this.timeFrame = this.fromDate || this.toDate ? 'Select' : this.timeFrame;
    if (this.fromDate && this.toDate) {
      this.singleDateError = false;
      if (this.fromDate.getTime() > this.toDate.getTime()) {
        this.dateError = true;
      } else {
        this.dateError = false;
      }
      this.isFilterSelected = true;
    }
  }

  clearDateRange() {
    this.fromDate = undefined;
    this.toDate = undefined;
    this.isFilterSelected = true;
    this.cd.detectChanges();
  }

  paymentMethodSelected() {
    this.applyFilter();
    this.getPaymentList();
  }

  generateSavePdf() {
    const options = {
      margin: [10, 10, 10, 10],
      filename: 'Order History.pdf',
      image: { type: 'jpeg' },
      html2canvas: {},
      jsPDF: { orientation: 'portrait' },
    };
    const element: Element = document.getElementById('ordersTable');
    html2pdf().from(element).set(options).save();
  }

  generateXls(allOrders) {
    const list = JSON.parse(JSON.stringify(allOrders));
    const orders = [];
    list.forEach((element) => {
      const invoices = Array.prototype.map
        .call(element.invoices, function (item) {
          return item.invoiceNumber;
        })
        .join(',');
      const trackingNumber = Array.prototype.map
        .call(element.tracking, function (item) {
          if (item.carrier && item.carrier !== 'YB') {
            return item.trackingNumber;
          }
        })
        .filter((item) => item !== undefined)
        .join(',');
      orders.push({
        Type: element.sapSystemType,
        'Order #': element.guid,
        Status: element.statusDisplay,
        'PO #': element.purchaseOrderNumber,
        'Invoice #': invoices,
        'Tracking #': trackingNumber,
      });
    });
    this.service.downloadXls(orders, 'OrderHistory');
    this.xlsDownloaded = true;
  }

  async generateSaveXls() {
    let xlsDownloadFilter: any = JSON.stringify(this.filters);
    this.xlsDownloaded = false;
    xlsDownloadFilter = JSON.parse(xlsDownloadFilter);
    xlsDownloadFilter.currentPage = 0;
    xlsDownloadFilter.pageSize = 1000;
    const params = { userId: this.userId.uid };
    this.service.getAllOrders(params, xlsDownloadFilter);
    this.allOrdersSubscription = this.service.allOrders$.subscribe((res) => {
      if (res !== null) {
        if (!this.xlsDownloaded) {
          this.generateXls(res?.orders);
          this.cd.detectChanges();
          this.service.allOrders?.next(null);
        }
      }
    });
  }

  clearFilters() {
    this.facetsList = [];
    this.filters = {
      fields: 'DEFAULT',
      timeFrame: 'All',
      currentPage: 0,
      pageSize: this.pageSize,
    };
    this.curPage = 1;
    this.invoice = undefined;
    this.fromDate = undefined;
    this.toDate = undefined;
    this.order = undefined;
    this.invoice = undefined;
    this.poNumber = undefined;
    this.paymentMethod = 'All';
    this.timeFrame = 'Select';
    this.getPaymentList();
    this.isFilterSelected = false;
    this.product = undefined;
    this.orderStatus = 'All';
    this.selectedTimeFrame = 'ALL';
    this.paymentFromDate = moment().subtract(2, 'years').calendar();
    this.paymentToDate = moment().format('L');
    this.clearPaymentSummaryFilter();
    this.hide();
  }

  onKeyPress(value: any) {
    if (value) this.isFilterSelected = true;
    this.cd.detectChanges();
  }

  getSelectedProduct(params) {
    if (params) this.isFilterSelected = true;
    this.product = params;
    this.cd.detectChanges();
  }
  asmStringCheck(invoiceNumber) {
    let val = /^\d+$/.test(invoiceNumber);
    return (
      !val ||
      invoiceNumber.length >= 11 ||
      invoiceNumber.length <= 7 ||
      (this.isAsmUser && this.paymentFullResult?.isComServeAgent)
    );
  }
}
